import { ERROR_PAGE_VIEW_EVENT } from 'constants/analytics';
import { ERROR_PAGE_TITLES } from 'constants/error';
import { logPageView } from 'helpers/mparticle';

export type ErrorPageType = 'chunk_load_failed' | 'general' | 'not_found' | 'unauthorized';

// Chrome, Firefox and Safari word a failed lazy import differently, and Vite words a failed CSS one
const CHUNK_LOAD_MESSAGE =
  /dynamically imported module|importing a module script failed|failed to load module script|unable to preload css/i;

export function isChunkLoadError(error: unknown) {
  const message = (error as { message?: unknown } | null | undefined)?.message;

  return typeof message === 'string' && CHUNK_LOAD_MESSAGE.test(message);
}

type ErrorPageTypeParams = {
  error?: unknown;
  isUnauthorized?: boolean;
  title?: string;
};

export function getErrorPageType({ error, isUnauthorized, title }: ErrorPageTypeParams) {
  if (isUnauthorized) return 'unauthorized';
  if (isChunkLoadError(error)) return 'chunk_load_failed';
  if (title === ERROR_PAGE_TITLES.notFound) return 'not_found';

  return 'general';
}

export function trackErrorPageViewed(params: { errorType: ErrorPageType; pathname: string }): void {
  logPageView(ERROR_PAGE_VIEW_EVENT, { error_type: params.errorType, pathname: params.pathname });
}
